<template>
  <div
    v-show="this.$store.state.layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${this.$store.state.darkMode ? 'bg-transparent' : 'bg-gradient-primary'}`"
  />
  <aside
    ref="sidenav"
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="`${
      this.$store.state.isRTL
        ? 'me-3 rotate-caret fixed-end'
        : 'fixed-start ms-3'
    } 
    ${
      this.$store.state.layout === 'landing'
        ? 'bg-transparent shadow-none'
        : ' '
    } ${this.$store.state.sidebarType}`"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <router-link class="m-0 navbar-brand text-center" to="/">

        <img
          :key="logoKey" 
          :src="
            this.$store.state.darkMode ||
            this.$store.state.sidebarType === 'bg-default'
              ? logoWhite
              : logoDark
          "
          class="navbar-brand-img h-100"
          alt="main_logo"
        /> 

      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="custom_class" />
  </aside>
</template>

<style scoped>
.logo, .logo-white {
  transition: opacity 1s ease-in-out;
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>

<script>
import SidenavList from "./SidenavList.vue";
import logoDefault from "@/assets/img/icon.png";
import logoWhiteDefault from "@/assets/img/icon_white.png";
import { mapMutations } from "vuex";


export default {
  name: "index",
  components: {
    SidenavList
  },
  data() {
    return {
      logoDark: logoDefault,
      logoWhite: logoWhiteDefault,
      apiUrl: process.env.VUE_APP_API_IMAGE_URL,
      logoKey: Date.now(),
    };
  },
  props: ["custom_class", "layout"],
  mounted() {
    this.fetchSettings();
 
    document.addEventListener("click", this.handleOutsideClick);
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),

    async fetchSettings() {

      const response = await this.$store.dispatch("settings/get");
      if (response && response.data.logo_path && response.status >= 200 && response.status < 300) {
        this.logoDark = this.apiUrl + response.data.logo_path_dark || logoDefault; 
        this.logoWhite =  this.apiUrl+ response.data.logo_path || logoWhiteDefault;
        this.logoKey = Date.now();
      }
    },
    handleOutsideClick(event) {

      //si el clic es del boton abrir menu, no se activa la funcion de ocultar menu al dar click en la pantalla
      if (event.target.closest("#iconNavbarSidenav")) {
        return;
      }

      //si el clic es dentro del menu no se cierra el menu
      if (event.target.closest("#sidenav-main")) { 
        return;
      }

      const sidenav = this.$refs.sidenav;
      const screenWidth = window.innerWidth;

      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (screenWidth < 1200 && sidenav && sidenav_show.classList.contains("g-sidenav-pinned")) {
        this.closeMenu();
      }
    },
    closeMenu() {
      this.navbarMinimize();
    }
  }
};
</script>
